module.exports = __webpack_public_path__ + "img/double_star.f1b377dd.svg";